import {
  DecrementAvailabilityResponse,
  IncrementAvailabilityResponse,
} from './src/service-plugins-types.js';
import {
  DecrementAvailabilityEnvelope,
  IncrementAvailabilityEnvelope,
} from './src/interfaces-ecommerce-v1-inventory-provider.public.js';

export * from './src/service-plugins-error-classes';
export * from './src/service-plugins-types';
export { DecrementAvailabilityEnvelope, IncrementAvailabilityEnvelope };

/**
 * Reduces the available stock quantity for specified items.
 *
 * Use this method when inventory needs to be decremented due to order events such as order placement or payment. The method supports validation to prevent negative inventory levels when `restrictInventoryValue` is set to true.
 * @throws DecrementNotPossibleWixError
 */
export declare function decrementAvailability(
  payload: DecrementAvailabilityEnvelope
): DecrementAvailabilityResponse | Promise<DecrementAvailabilityResponse>;
/**
 * Increases the available stock quantity for specified items.
 *
 * Use this method when inventory needs to be incremented due to order events such as order cancellation, refund, or order editing.
 * This method does not validate stock levels and allows negative inventory to be corrected.
 * @throws IncrementNotPossibleWixError
 */
export declare function incrementAvailability(
  payload: IncrementAvailabilityEnvelope
): IncrementAvailabilityResponse | Promise<IncrementAvailabilityResponse>;
